import { WizardStepTree } from '../../../../wizard/interfaces/wizard-step';
import { EditPipelineStepGroups } from '../interfaces/edit-pipeline-step-paths';

export const EDIT_PIPELINE_STEP_GROUPS: WizardStepTree = {
  for: '',
  title: 'Edit Pipeline',
  id: 'edit-pipeline',
  children: [
    {
      title: 'Pipeline Configuration',
      for: EditPipelineStepGroups.PIPELINE_CONFIGURATION,
      id: EditPipelineStepGroups.PIPELINE_CONFIGURATION,
      children: []
    },
    {
      title: 'Object Configuration',
      for: EditPipelineStepGroups.OBJECT_CONFIGURATION,
      id: EditPipelineStepGroups.OBJECT_CONFIGURATION,
      children: []
    },
    {
      title: 'Review',
      for: EditPipelineStepGroups.REVIEW,
      id: EditPipelineStepGroups.REVIEW,
      children: []
    }
  ]
};
